import React, { useContext } from "react";

export const ApiContext = React.createContext();

function useApi() {
  return useContext(ApiContext);
}

export default useApi;
